import React from 'react';

// Styles & Assets
import styles from './DialogRouteStart.module.css';

// Services
import { getUserGeolocalization } from '../../../services/getRoute';

// Context
import GeneralContext from '../../../context/GeneralContext';

// Hooks
import { useContext } from 'react';

// Language 
import { useTranslation } from 'react-i18next';

// Other
import { Link } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';

// DialogRouteStart: renders dialog that lets the user choose between creating a 
// route either from the user's location or from the hospital. Then navigates 
// to the /set-up-route route sending the route and the hospital location if 
// selected. Props:
//      - getRoute: function that returns the route name and the patientsIDs
const DialogRouteStart: React.FC<{
    getRoute: () => { name: string, patients: number[] }
}> = ({ getRoute }) => {

    const navigate = useNavigate();

    const { t } = useTranslation();

    const generalContext = useContext(GeneralContext);

    const getLocationHospital = () => generalContext.hospitalLocation;

    const handleClickLocation = () => {
        getUserGeolocalization().then(resPos => {
            if (resPos !== undefined) navigate('/home/routes/set-up-route', {state: {route: getRoute(), location: resPos}});
        });
    };

    return (
        <div className='dialog'>
            <h2 className={styles.routeStartTitle}>{t('want_start_route')}</h2>
            <div className={styles.linksContainer}>
                <Link
                    to={'/home/routes/set-up-route'}
                    state={{ route: getRoute(), location: getLocationHospital() }}
                    className={`${styles.hospitalButton} anchorButton`}
                >
                    {t('hospital')}
                </Link>
                <button
                    onClick={handleClickLocation}
                    className={`${styles.locationButton} button`}
                >
                    {t('current_location')}
                </button>
            </div>
        </div>
    );
};

export default DialogRouteStart;